import React from "react";
import PrintLinks from "./PrintLinks";
import PrintP2PLinks from "./PrintP2PLinks";
import PrintLTLinks from "./PrintLTLinks";
import PrintLeasingLinks from "./PrintLeasingLinks";
import SecurityControls from "./SecurityControls.js";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";

class LoanClosed extends React.Component {
    render() {
        const {
            contractId,
            car,
            sum,
            isJur,
            manager,
            programType,
            onDuplicateClient,
            onAddComment,
            onDeleteComment
        } = this.props;

        return (
            <React.Fragment>
                <Paper
                    className="common-paper"
                    style={{ marginTop: 20, marginBottom: 20 }}
                >
                    <div className="common-form wide-column">
                        <Typography variant="h5" gutterBottom>
                            Договор закрыт
                        </Typography>
                        <Button
                            onClick={() => onDuplicateClient(car)}
                            size="large"
                            color="primary"
                            variant="contained"
                        >
                            Открыть повторно
                        </Button>
                        <Typography variant="h5" gutterBottom>
                            Печать документов
                        </Typography>
                        {
                            {
                                PTS_LEASING: (
                                    <PrintLeasingLinks
                                        id={contractId}
                                        isJur={isJur}
                                    />
                                ),
                                HOLD_LT: (
                                    <PrintLTLinks
                                        id={contractId}
                                        sum={sum}
                                        manager={manager}
                                    />
                                ),
                                PTS_P2P: (
                                    <PrintP2PLinks id={contractId} sum={sum} />
                                ),
                                HOLD: (
                                    <PrintLinks
                                        id={contractId}
                                        programType={programType}
                                        sum={sum}
                                    />
                                ),
                                PTS: (
                                    <PrintLinks
                                        id={contractId}
                                        programType={programType}
                                        sum={sum}
                                    />
                                )
                            }[programType]
                        }
                    </div>
                </Paper>
                <SecurityControls
                    car={car}
                    onAddComment={onAddComment}
                    onDeleteComment={onDeleteComment}
                />
            </React.Fragment>
        );
    }
}

export default LoanClosed;



// WEBPACK FOOTER //
// ./src/components/LoanClosed.js